import React from "react";
import List from "../components/inputs/List";
import PROJECT_CONFIG from "../config/projectConfig";

const About = () => {
  return (
    <div className="bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="rounded-lg shadow-sm p-8">
          <h1 className="text-4xl font-bold text-gray-900 mb-8">
            About {PROJECT_CONFIG.name}
          </h1>

          {/* About the Scientific Resolution Panel Section */}
          <section className="mb-12">
            <h2 className="text-2xl font-bold text-gray-900 mb-6">
              About the {PROJECT_CONFIG.fullName} ({PROJECT_CONFIG.name})
            </h2>

            <div className="prose max-w-none text-left">
              <p className="text-gray-700 mb-6 leading-relaxed text-left">
                Under contract with FEMA, the National Institute of Building
                Sciences (NIBS) establishes {PROJECT_CONFIG.name} panels to
                independently review scientific and technical data for FEMA's
                flood hazard determination data for the National Flood Insurance
                Program's Flood Insurance Rate Maps. {PROJECT_CONFIG.name}{" "}
                panels review FEMA's data and community-submitted data to
                determine technical and scientific accuracy, rendering a written
                decision that accepts or denies alternative flood hazard data.
                The Panel's decision serves as a recommendation to the FEMA
                Administrator for resolving conflicting data.
              </p>

              <div className="mb-6">
                <p className="text-gray-700 mb-4 leading-relaxed text-left">
                  {PROJECT_CONFIG.name} panels are established to achieve
                  benefits for both FEMA and communities:
                </p>
                <List
                  items={[
                    "Offer a process deemed neutral for all parties.",
                    "Offer the best independent scientific and technical expertise available to review and decide on conflicting flood hazard data and flood maps.",
                    "Provide faster resolution to community challenges of proposed flood hazard data.",
                  ]}
                  withMargin
                />
              </div>

              <p className="text-gray-700 leading-relaxed text-left">
                An {PROJECT_CONFIG.name} panel is not the first step toward
                resolution. Historically, FEMA uses community consultation to
                resolve appeals and challenges to proposed flood hazard data.
                FEMA is committed to community consultation for resolving
                conflicting data in an interactive, less structured process,
                which usually leads to satisfactory resolution. This
                consultation process is also effective when a community's
                challenge doesn't meet statutory or regulatory requirements for
                an appeal. The {PROJECT_CONFIG.name} becomes available when
                community consultation cannot produce a mutually acceptable
                resolution.
              </p>
            </div>
          </section>

          {/* Who May Serve on a Panel Section */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-6">
              Who May Serve on a Panel
            </h2>

            <div className="prose max-w-none text-left">
              <p className="text-gray-700 mb-6 leading-relaxed text-left">
                Interested professionals must have a minimum of 10 years of
                proven experience with expertise in one of the following fields
                or a related field:
              </p>

              <List
                items={[
                  "Coastal storm and hydraulic engineering",
                  "Coastal engineering",
                  "Water resource engineering (surface water hydrology, open-channel flow hydraulics, hydrologic engineering)",
                  "Geotechnical engineering",
                  "Alluvial fan engineering",
                  "Levee design and mapping",
                  "1D and 2D floodway/floodplain analysis",
                  "FEMA guidelines and standards for flood risk analysis and mapping",
                ]}
                withMargin
                className="mb-6"
              />

              <p className="text-gray-700 leading-relaxed text-left">
                Professionals must also have expertise with riverine,
                lacustrine, coastal flood hazard, surveying, topographic
                information, hydrologic analysis, hydraulic analysis, coastal
                analysis, or other pertinent experience applicable to the
                development of flood elevations and Flood Insurance Rate Maps
                (FIRMs).
              </p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default About;
